import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  actor_types: [],
  actor_type: null
}

// mutations
export const mutations = {
  [types.SET_ACTOR_TYPES] (state, actor_types) {
    state.actor_types = actor_types
  },
  [types.SET_ACTOR_TYPE] (state, actor_type) {
    state.actor_type = actor_type
  },
  [types.FETCH_ACTOR_TYPE_FAILURE] (state) {
    state.actor_type = null
  }
}

// actions
export const actions = {
  async fetchActorTypes ({ commit }) {
    try {
      const { data } = await axios.get('/api/actor_types')
      commit(types.SET_ACTOR_TYPES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchActorType ({ commit }, actor_type) {
    try {
      const { data } = await axios.get(`/api/actor_types/${actor_type.id}`)

      commit(types.SET_ACTOR_TYPE, { actor_type: data })
    } catch (e) {
      commit(types.FETCH_ACTOR_TYPE_FAILURE)
    }
  },

  async createActorType (context, actor_type) {
    try {
      await axios.post('/api/actor_types', actor_type)
      context.dispatch('fetchActorTypes')
    } catch (e) {
      console.log(e)
    }
  },

  async updateActorType (context, actor_type) {
    try {
      await axios.put(`/api/actor_types/${actor_type.id}`, actor_type)
      context.dispatch('fetchActorTypes')
    } catch (e) { }
  },

  async deleteActorType (context, actor_type) {
    try {
      await axios.delete(`/api/actor_types/${actor_type.id}`)
      context.dispatch('fetchActorTypes')
    } catch (e) { }
  }
}

// getters
export const getters = {
  actor_types: state => state.actor_types
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/actor-type.js